import { bTag } from '../../../../core'
import { LOAD_TYPE } from '../selectTagsModal'
import { ITagsProps } from '../../../../shared/hooks/api/useTagsList';

interface FilterChildrens {
    tagsFilter: ITagsProps
    rawChildrens: any
    loadType: number
    v: any
    isEditProjectPage: boolean
    isTagsSearchPage?: boolean
    useTagId?: boolean
}

//test

export const filterChildrens = (props: FilterChildrens) => {
    const { tagsFilter, rawChildrens, loadType, v, isEditProjectPage, isTagsSearchPage, useTagId } = props
    const searchedTag = tagsFilter?.search && tagsFilter.search[0] || ''
    const checkedCategoryId = useTagId ? v.tagId : v.categoryId
    const isOpenCategory = v.typeCategory === 'open'
    const needFilter: any = (loadType === LOAD_TYPE.tagsSearchIntoCategory) && 
        (tagsFilter.groupIds && tagsFilter.groupIds[0] === checkedCategoryId) && 
        searchedTag.length; //&& rawChildrens.length не уверен, можно ли это условие закоментировать
    
    if(!needFilter) {
        return rawChildrens
    }
    const filteredChildrens = rawChildrens.filter((itemTag: any) => {
        return itemTag && bTag.title(itemTag)?.toLocaleLowerCase()?.includes((searchedTag?.toLocaleLowerCase()))
    })

    return filteredChildrens?.length
        ? filteredChildrens
        : ((isEditProjectPage && isOpenCategory) || (isTagsSearchPage && isOpenCategory))
            ? [{
                parentTag: { ...v, tagId: checkedCategoryId },
                name: searchedTag,
                title: searchedTag,
                isNewTag: true,
            }]
            : rawChildrens
}import { bTag } from '../../../../core'
import { LOAD_TYPE } from '../selectTagsModal'
import { ITagsProps } from '../../../../shared/hooks/api/useTagsList';

interface FilterChildrens {
    tagsFilter: ITagsProps
    rawChildrens: any
    loadType: number
    v: any
    isEditProjectPage: boolean
    isTagsSearchPage?: boolean
    useTagId?: boolean
}

//test

export const filterChildrens = (props: FilterChildrens) => {
    const { tagsFilter, rawChildrens, loadType, v, isEditProjectPage, isTagsSearchPage, useTagId } = props
    const searchedTag = tagsFilter?.search && tagsFilter.search[0] || ''
    const checkedCategoryId = useTagId ? v.tagId : v.categoryId
    const isOpenCategory = v.typeCategory === 'open'
    const needFilter: any = (loadType === LOAD_TYPE.tagsSearchIntoCategory) && 
        (tagsFilter.groupIds && tagsFilter.groupIds[0] === checkedCategoryId) && 
        searchedTag.length; //&& rawChildrens.length не уверен, можно ли это условие закоментировать
    
    if(!needFilter) {
        return rawChildrens
    }
    const filteredChildrens = rawChildrens.filter((itemTag: any) => {
        return itemTag && bTag.title(itemTag)?.toLocaleLowerCase()?.includes((searchedTag?.toLocaleLowerCase()))
    })

    return filteredChildrens?.length
        ? filteredChildrens
        : ((isEditProjectPage && isOpenCategory) || (isTagsSearchPage && isOpenCategory))
            ? [{
                parentTag: { ...v, tagId: checkedCategoryId },
                name: searchedTag,
                title: searchedTag,
                isNewTag: true,
            }]
            : rawChildrens
}